import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { authorizationStatusOptions } from '../config';
import { AuthorizationsFilter } from '../models';
import { useSearchBar } from '../hooks/useSearchBar';
import {
  GlobalButton,
  AutocompleteInput,
  SelectInput,
  DateInput,
} from '@/components';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';

interface SearchBarProps {
  onSearch: (filters: AuthorizationsFilter) => void;
  initialFilter: AuthorizationsFilter;
  currentFilter: AuthorizationsFilter;
}

export const SearchBar = ({
  onSearch,
  initialFilter,
  currentFilter,
}: SearchBarProps) => {
  const {
    localFilter,
    selectedDriver,
    driverOptions,
    isDriversLoading,
    selectedUser,
    userOptions,
    isUsersLoading,
    setDriverSearch,
    setUserSearch,
    handleDriverSelect,
    handleUserSelect,
    handleStatusSelect,
    handleRequestedFromSelect,
    handleRequestedToSelect,
    resetFilter,
    handleSearch,
  } = useSearchBar({ onSearch, initialFilter, currentFilter });

  return (
    <div className='w-full flex flex-col justify-center gap-5 p-5 bg-white rounded-sm shadow-xl'>
      <h4 className='text-xl font-black text-gray-800'>Filtros de Búsqueda</h4>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-5'>
        <AutocompleteInput
          name='auth-driver-search'
          placeholder='Conductor'
          value={selectedDriver}
          onChange={handleDriverSelect}
          onInputChange={setDriverSearch}
          options={driverOptions}
          required={false}
          loading={isDriversLoading}
        />
        <AutocompleteInput
          name='auth-user-search'
          placeholder='Autorizado por'
          value={selectedUser}
          onChange={handleUserSelect}
          onInputChange={setUserSearch}
          options={userOptions}
          required={false}
          loading={isUsersLoading}
        />
        <SelectInput
          name='auth-status-search'
          placeholder='Estado'
          value={localFilter.status || ''}
          onChange={handleStatusSelect}
          options={authorizationStatusOptions}
        />
        <DateInput
          name='auth-requested-from'
          placeholder='Fecha Solicitud Desde'
          value={localFilter.requestedFrom ? new Date(localFilter.requestedFrom) : null}
          onChange={handleRequestedFromSelect}
        />
        <DateInput
          name='auth-requested-to'
          placeholder='Fecha Solicitud Hasta'
          value={localFilter.requestedTo ? new Date(localFilter.requestedTo) : null}
          onChange={handleRequestedToSelect}
        />
      </div>
      <div className='flex gap-3 justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={handleSearch}
        >
          <SearchIcon sx={{ color: 'white' }} />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
